import { useRef } from 'react'
import { toast } from 'react-hot-toast'

import { ToastType } from '@/types/forms/uploadFiles'

let toastCounter = 0

const generateUniqueId = (prefix: ToastType) => {
    toastCounter += 1
    const random = Math.random().toString(36).substring(2, 15)
    const timestamp = Date.now()

    return `${prefix}-${random}-${timestamp}-${toastCounter}`
}

export const useToastManager = () => {
    const operationIds = useRef(new Set<string>())
    const activeToasts = useRef(new Set<string>())

    const showErrorToast = (message: string, type: ToastType) => {
        const toastId = generateUniqueId(type)

        if (!activeToasts.current.has(toastId)) {
            activeToasts.current.add(toastId)
            toast.error(message, {
                id: toastId,
                duration: 3000,
                onDismiss: () => activeToasts.current.delete(toastId)
            })
        }
    }

    return {
        operationIds,
        activeToasts,
        generateUniqueId,
        showErrorToast
    }
}
